interface ModalCategorySelectionProps {
  outraCategoria: string;
  onSelectELBB: () => void;
  onSelectOutra: () => void;
}

const LABELS: Record<string, { nome: string; descricao: string }> = {
  CONEXAO: { nome: "Negócios e Atendimento", descricao: "Plataforma Conexão" },
  JJ_PREDEFINIDO: { nome: "Pilar de Sustentação", descricao: "Iniciativa Estruturante" },
};

export function ModalCategorySelection({ outraCategoria, onSelectELBB, onSelectOutra }: ModalCategorySelectionProps) {
  const outra = LABELS[outraCategoria] || { nome: outraCategoria, descricao: "" };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6 sm:p-8 animate-fade-in">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800 text-center mb-3">
          Selecione sua categoria de participação
        </h2>

        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 sm:p-4 mb-6">
          <p className="text-amber-800 text-sm sm:text-base text-center font-medium">
            Você está habilitado em duas categorias. Escolha em qual deseja
            se inscrever.
          </p>
          <p className="text-amber-700 text-xs sm:text-sm text-center mt-1">
            Atenção: você só poderá se inscrever em <strong>uma categoria</strong>.
          </p>
        </div>

        <div className="flex flex-col gap-3 sm:gap-4">
          <button
            onClick={onSelectELBB}
            className="w-full p-4 sm:p-5 rounded-xl border-2 border-blue-200 hover:border-blue-500 hover:bg-blue-50 transition-all text-left group"
          >
            <span className="text-lg sm:text-xl font-semibold text-blue-700 group-hover:text-blue-800">
              ELBB
            </span>
            <p className="text-sm text-gray-500 mt-1">
              Estratégia Líderes do BB
            </p>
          </button>

          <button
            onClick={onSelectOutra}
            className="w-full p-4 sm:p-5 rounded-xl border-2 border-green-200 hover:border-green-500 hover:bg-green-50 transition-all text-left group"
          >
            <span className="text-lg sm:text-xl font-semibold text-green-700 group-hover:text-green-800">
              {outra.nome}
            </span>
            <p className="text-sm text-gray-500 mt-1">
              {outra.descricao}
            </p>
          </button>
        </div>
      </div>
    </div>
  );
}
